import { Observable } from 'rxjs';
import { IGetBankingAccountModelResult } from '../../model/banking-account/iBankingAccountResult.model';
import { HttpHeaders } from '@angular/common/http';
import { IUpdateBankingAccountResponse } from '../../model/banking-account/iUpdateBankingAccountResponse.model';
import { BaseProxy } from '../base.proxy';
import { Injectable } from '@angular/core';
import { IAccountFundData } from '../../model/banking-account/iAccountFundData';
import { IUpdateBankingAccount } from '../../model/banking-account/iUpdateBankingAccount.model';
import { ICountryModel } from '../../model/banking-account/iCountry.model';
import { IBankingDeleteAccountModel } from '../../model/banking-account/IBankingDeleteAccountModel.model';
import { IUpdateResponse } from '../../model/banking-account/IUpdateResponse';
import { ICopyAccountModel } from '../../model/banking-account/ICopyAccount.model';
import { IDeleteAccountModel } from '../../model/banking-account/IDeleteAccount.model';
import { ICurrencyModel } from '../../model/banking-account/iCurrency.model';
import { ICancelApprovalRequest } from '../../model/banking-account/iCancelApprovalRequest.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class BankingAccountProxy extends BaseProxy{

  getBankingAccounts(accountIds?: number[]): Observable<IGetBankingAccountModelResult>{
    if (environment.feature.newApi === false) {
      return this._http.post<IGetBankingAccountModelResult>('/ip/api/bankaccountinfo/getbankaccountinfo', {accountIds});
    } else {
      return this._http.post<IGetBankingAccountModelResult>('/ip-api/api/bankaccount/getbankaccountinfo', {accountIds});
    }
  }

  getFundBankAccountInfo(accountIds?: number[]): Observable<IAccountFundData[]>{
    if (environment.feature.newApi === false) {
      return this._http.post<IAccountFundData[]>('/ip/api/bankaccountinfo/getfundbankaccountinfo', {companyIds: accountIds});
    } else {
      return this._http.post<IAccountFundData[]>('/ip-api/api/bankaccount/getfundbankaccountinfo', {companyIds: accountIds});
    }
  }

  deleteBankAccounts(deleteAccountObj: IDeleteAccountModel){
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        dealRelationshipIds: [deleteAccountObj.bankAccountId],
        kbaType: deleteAccountObj.kbaType,
        kbaAnswer: deleteAccountObj.kbaAnswer
      }
    };
    if (environment.feature.newApi === false) {
      return this._http.delete<IBankingDeleteAccountModel>('/ip/api/bankaccountinfo/deletebankaccountinfo', options );
    } else {
      return this._http.delete<IBankingDeleteAccountModel>('/ip-api/api/bankaccount/deletebankaccountinfo', options );
    }
  }

  updateBankAccounts(updatedAccounts: IUpdateBankingAccount): Observable<IUpdateBankingAccountResponse>{
    if (environment.feature.newApi === false) {
      return this._http.post<IUpdateBankingAccountResponse>('/ip/api/bankaccountinfo/updatebankaccountinfo', updatedAccounts);
    } else {
      return this._http.post<IUpdateBankingAccountResponse>('/ip-api/api/bankaccount/updatebankaccountinfo', updatedAccounts);
    }
  }

  getTaxId(bankAccountIds: number[]): Observable<boolean> {
    if (environment.feature.newApi === false) {
      return this._http.post<boolean>('/ip/api/bankaccountinfo/hastaxid', bankAccountIds)
    } else {
      return this._http.post<boolean>('/ip-api/api/bankaccount/hastaxid', bankAccountIds)
    }
  }

  createBankAccount(updatedAccounts: IUpdateBankingAccount): Observable<IUpdateBankingAccountResponse>{
    if (environment.feature.newApi === false) {
      return this._http.post<IUpdateBankingAccountResponse>('/ip/api/bankaccountinfo/addbankaccount', updatedAccounts);
    } else {
      return this._http.post<IUpdateBankingAccountResponse>('/ip-api/api/bankaccount/addbankaccount', updatedAccounts);
    }
  }

  getBankAccountCountries(): Observable<ICountryModel[]>{
    if (environment.feature.newApi === false) {
      return this._http.post<ICountryModel[]>('/ip/api/bankaccountinfo/getcountrycodes', {});
    } else {
      return this._http.post<ICountryModel[]>('/ip-api/api/bankaccount/getcountrycodes', {});
    }
  }

  getBankAccountCurrencies(): Observable<ICurrencyModel[]>{
    if (environment.feature.newApi === false) {
      return this._http.post<ICurrencyModel[]>('/ip/api/bankaccountinfo/getcurrencycodes', {});
    } else {
      return this._http.post<ICurrencyModel[]>('/ip-api/api/bankaccount/getcurrencycodes', {});
    }
  }

  copyBankAccountDetails(copiedBankAccounts: ICopyAccountModel): Observable<IUpdateResponse>{
    if (environment.feature.newApi === false) {
      return this._http.put<IUpdateResponse>('/ip/api/bankaccountinfo/CopyBankAccountDetails', copiedBankAccounts);
    } else {
      return this._http.put<IUpdateResponse>('/ip-api/api/bankaccount/CopyBankAccountDetails', copiedBankAccounts);
    }
  }

  cancelBankAccountRequest(cancelObj: ICancelApprovalRequest): Observable<IUpdateBankingAccountResponse>{
    if (environment.feature.newApi === false) {
      return this._http.put<IUpdateBankingAccountResponse>('/ip/api/bankaccountinfo/cancelbankaccountrequest', cancelObj );
    } else {
      return this._http.put<IUpdateBankingAccountResponse>('/ip-api/api/bankaccount/cancelbankaccountrequest', cancelObj );
    }
  }

  uploadFiles(files: File[]): Observable<any>{
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append('file', file, file?.name)
    });

    if (environment.feature.newApi === false) {
      return this._http.post<any>('/ip/api/file/upload', formData, {reportProgress: true, observe: 'events'});
    } else {
      return this._http.post<any>('/ip-api/api/file/bankaccount/upload', formData, {reportProgress: true, observe: 'events'});
    }
  }
}
